var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useDesign from '../../../hooks/useDesign';
import { SROnlyLink } from '../../../theme/accessibility';
import { ContentContainer } from '../../templates/ContentContainer';
import { PageWrapper } from './styled';
export var HeaderContentFooter = function (_a) {
    var design = _a.design, children = _a.children;
    var _b = useDesign(design), components = _b.components, schema = _b.schema;
    return (_jsxs(PageWrapper, __assign({ schema: schema }, { children: [_jsx(SROnlyLink, __assign({ href: "#main" }, { children: "Skip to main content" })), _jsx(ContentContainer, { design: components.header }), children, _jsx(ContentContainer, { design: components.footer })] }), design));
};
HeaderContentFooter.displayName = 'HeaderContentFooter';
